// Bilingual content for NACUII (English / Spanish). English is the default.

import { images, driveImages } from "../data/images";

export const translations = {
  nav: {
    home: { en: "Home", es: "Inicio" },
    residence: { en: "The Residence", es: "La Residencia" },
    architecture: { en: "Architecture", es: "Arquitectura" },
    amenities: { en: "Amenities", es: "Amenidades" },
    gallery: { en: "Gallery", es: "Galería" },
    rates: { en: "Rates", es: "Tarifas" },
    location: { en: "Location", es: "Ubicación" },
    faq: { en: "FAQ", es: "FAQ" },
    contact: { en: "Contact", es: "Contacto" },
    bookVisit: { en: "Book a visit", es: "Reservar visita" }
  },
  hero: {
    eyebrow: {
      en: "Beachfront Residence — Las Tunas, Todos Santos",
      es: "Residencia Frente al Mar — Las Tunas, Todos Santos"
    },
    title1: { en: "Elegance and charm in", es: "Elegancia y encanto en" },
    title2: { en: "harmony with nature.", es: "armonía con la naturaleza." },
    discover: { en: "Discover the residence", es: "Descubrir la residencia" },
    bookVisit: { en: "Book a visit", es: "Reservar una visita" }
  },
  about: {
    eyebrow: { en: "Welcome", es: "Bienvenido" },
    title1: {
      en: "Your own residence facing the Pacific,",
      es: "Su propia residencia frente al Pacífico,"
    },
    title2: {
      en: "in the heart of Todos Santos.",
      es: "en el corazón de Todos Santos."
    },
    p1: {
      en: "NACUII is an exclusive, freestanding beachfront residence in Todos Santos. With an efficient design, uninterrupted Pacific Ocean views and spectacular sunsets, it sits on a 3,000 m² lot in the prestigious Las Tunas neighborhood.",
      es: "NACUII es una exclusiva residencia independiente, frente al mar en Todos Santos. Con un diseño eficiente, vistas ininterrumpidas del Pacífico y atardeceres espectaculares, se asienta sobre un lote de 3,000 m² en el prestigioso barrio de Las Tunas."
    },
    p2: {
      en: "Just steps away you will find the famous La Pastora surf beach; a ten-minute drive takes you to the charming shops, galleries and restaurants of this Magic Town.",
      es: "A pocos pasos encontrará la famosa playa de surf La Pastora; a diez minutos en automóvil, las encantadoras tiendas, galerías y restaurantes del Pueblo Mágico."
    },
    p3: {
      en: "The property is located less than 70 minutes from Los Cabos International Airport, and the same distance from La Paz International Airport, offering unparalleled privacy without sacrificing connection to the world.",
      es: "La propiedad se encuentra a menos de 70 minutos del aeropuerto internacional de Los Cabos y a la misma distancia del aeropuerto internacional de La Paz, ofreciendo una privacidad incomparable sin renunciar a la conexión con el mundo."
    },
    quote: {
      en: "\u201cIt is not just a residence: it is a dream sanctuary where luxury, comfort and natural beauty merge to create an unparalleled living experience.\u201d",
      es: "\u00abNo es solo una residencia: es un refugio de ensueño donde el lujo, la comodidad y la belleza natural se fusionan para crear una experiencia de vida inigualable.\u00bb"
    }
  },
  award: {
    eyebrow: { en: "Recognition", es: "Reconocimiento" },
    title1: { en: "An architectural jewel", es: "Una joya arquitectónica" },
    title2: { en: "facing the Pacific.", es: "frente al Pacífico." },
    cta: { en: "Discover the design", es: "Conocer el diseño" },
    badgeTop: { en: "Architectural Jewel", es: "Joya Arquitectónica" },
    badgeBottom: { en: "Limited Edition", es: "Edición Limitada" }
  },
  architecture: {
    eyebrow: { en: "Architecture & Design", es: "Arquitectura & Diseño" },
    title1: { en: "Details that", es: "Detalles que" },
    title2: { en: "make the difference.", es: "marcan la diferencia." },
    block1: {
      label: { en: "01 — Open layout", es: "01 — Trazo abierto" },
      title1: { en: "Spaces that flow", es: "Espacios que fluyen" },
      title2: { en: "with nature.", es: "con la naturaleza." },
      text: {
        en: "Its open layout seamlessly integrates indoor and outdoor spaces, creating a harmonious flow with nature. Generous windows flood every room with natural light, allowing you to absorb the breathtaking views of the Pacific Ocean.",
        es: "Su trazo abierto integra perfectamente los espacios interiores con el exterior, creando un flujo armónico con la naturaleza. Amplios ventanales inundan cada habitación con luz natural, permitiéndole absorber las impresionantes vistas del mar Pacífico."
      }
    },
    block2: {
      label: { en: "02 — Contemporary tradition", es: "02 — Tradición contemporánea" },
      title1: { en: "Modern design with", es: "Diseño moderno con un" },
      title2: { en: "a touch of tradition.", es: "toque de tradición." },
      text: {
        en: "NACUII represents a state-of-the-art beach house project. The main level enjoys wraparound terraces, while informal gatherings around the pool can take advantage of the outdoor BBQ and fire pit, all under the starry skies of Baja California Sur.",
        es: "NACUII representa un proyecto avanzado en casas de playa. El nivel principal disfruta de terrazas envolventes, mientras que las reuniones informales en la piscina pueden aprovechar el BBQ exterior y el fire pit, todo bajo el cielo estrellado de Baja California Sur."
      }
    },
    block3: {
      label: { en: "03 — Artisan carpentry", es: "03 — Carpintería artesanal" },
      title1: { en: "Rosewood and", es: "Madera de rosa morada y" },
      title2: { en: "natural finishes.", es: "acabados naturales." },
      text: {
        en: "Attention to detail is evident throughout the home: custom carpentry in rosewood, made-to-measure pergolas and finishes polished with natural pigments. Every corner reveals the meticulous thinking invested in creating this exceptional residence.",
        es: "La atención al detalle es evidente en toda la casa: carpintería personalizada en madera de rosa morada, pérgolas diseñadas a medida y acabados pulidos con pigmentos naturales. Cada rincón demuestra el meticuloso pensamiento que se ha invertido en crear esta excepcional residencia."
      }
    }
  },
  amenities: {
    eyebrow: { en: "Amenities & Services", es: "Amenidades & Servicios" },
    title1: { en: "Every space,", es: "Cada espacio," },
    title2: { en: "an experience.", es: "una experiencia." },
    intro: {
      en: "Infinity pool, jacuzzi, sun deck, palapa, fire pit and private vehicular access. NACUII was conceived for an uncompromised oceanfront lifestyle.",
      es: "Alberca infinita, jacuzzi, asoleadero, palapa, fire pit y acceso vehicular privado. NACUII fue concebido para una vida frente al mar sin compromisos."
    },
    items: [
      {
        key: "pool",
        image: driveImages.poolInfinity,
        name: { en: "Infinity Pool", es: "Alberca Infinita" },
        desc: {
          en: "Infinity pool with cascade and Pacific Ocean views.",
          es: "Alberca infinita con cascada y vista al Pacífico."
        }
      },
      {
        key: "jacuzzi",
        image: driveImages.poolFountain,
        name: { en: "Jacuzzi", es: "Jacuzzi" },
        desc: {
          en: "Private outdoor jacuzzi.",
          es: "Jacuzzi privado al aire libre."
        }
      },
      {
        key: "sundeck",
        image: driveImages.outdoorTerrace,
        name: { en: "Sun Deck", es: "Asoleadero" },
        desc: {
          en: "Open-air relaxation area under the sun.",
          es: "Espacio de descanso al aire libre bajo el sol."
        }
      },
      {
        key: "bbq",
        image: driveImages.bbqGrill,
        name: { en: "Palapa & BBQ", es: "Palapa & BBQ" },
        desc: {
          en: "Grill area with traditional palapa.",
          es: "Área de asador con palapa tradicional."
        }
      },
      {
        key: "firepit",
        image: driveImages.firepitArea,
        name: { en: "Fire Pit", es: "Fire Pit" },
        desc: {
          en: "Outdoor fire pit facing the ocean.",
          es: "Hoguera al aire libre frente al mar."
        }
      },
      {
        key: "lounge",
        image: driveImages.villaPoolView,
        name: { en: "Pool Lounge", es: "Área de Descanso" },
        desc: {
          en: "Open lounge area surrounding the infinity pool.",
          es: "Área de descanso al aire libre alrededor de la alberca."
        }
      },
      {
        key: "interior",
        image: driveImages.exteriorRender2,
        name: { en: "Indoor Living", es: "Sala Interior" },
        desc: {
          en: "Open social area with seamless indoor-outdoor flow.",
          es: "Área social abierta con flujo continuo entre interior y exterior."
        }
      }
    ]
  },
  specs: {
    eyebrow: { en: "The Residence", es: "La Residencia" },
    title1: { en: "Private", es: "Especificaciones" },
    title2: { en: "specifications.", es: "privativas." },
    summary: {
      en: "5 Bedrooms · 6 Bathrooms · Contemporary Style",
      es: "5 Recámaras · 6 Baños · Estilo Contemporáneo"
    },
    items: [
      {
        label: { en: "Total Living Area", es: "Total Área Habitable" },
        value: "683.55 m²",
        sub: "7,357.5 ft²"
      },
      {
        label: { en: "Air-Conditioned Area", es: "Área Climatizada" },
        value: "280.85 m²",
        sub: "3,023 ft²"
      },
      {
        label: { en: "Ground Floor Terraces", es: "Terrazas Planta Baja" },
        value: "176.4 m²",
        sub: "1,898.7 ft²"
      },
      {
        label: { en: "Upper Floor Terraces", es: "Terrazas Planta Alta" },
        value: "72 m²",
        sub: "775 ft²"
      },
      {
        label: { en: "Pool", es: "Alberca" },
        value: "54 m²",
        sub: "581.2 ft²"
      },
      {
        label: { en: "Sun Deck", es: "Asoleadero" },
        value: "100.3 m²",
        sub: "1,079.6 ft²"
      },
      {
        label: { en: "Lot Size", es: "Terreno" },
        value: "3,000 m²",
        sub: "0.74 acres"
      },
      {
        label: { en: "Style", es: "Estilo" },
        value: { en: "Contemporary", es: "Contemporáneo" },
        sub: { en: "Ocean & Sierra", es: "Mar y Sierra" }
      }
    ],
    viewLabel: { en: "View", es: "Vista" },
    viewText: {
      en: "Pacific Ocean and Sierra de la Laguna — east/west orientation with a direct view of the sunset.",
      es: "Mar Pacífico y Sierra de la Laguna — orientación este/oeste con vista directa a la puesta del sol."
    },
    techLabel: { en: "Technology", es: "Tecnología" },
    techText: {
      en: "Whole-house water filtration system, biodigester, automated irrigation and mini-split AC in every area. Discreet comfort throughout.",
      es: "Sistema de filtración de agua para toda la casa, biodigestor, riego automatizado y minisplits en cada área. Confort discreto en cada habitación."
    }
  },
  gallery: {
    eyebrow: { en: "Gallery", es: "Galería" },
    title1: { en: "Interiors &", es: "Interiores &" },
    title2: { en: "exteriors.", es: "exteriores." },
    filters: {
      all: { en: "All", es: "Todos" },
      exterior: { en: "Exterior", es: "Exterior" },
      interior: { en: "Interior", es: "Interior" },
      architecture: { en: "Architecture", es: "Arquitectura" }
    }
  },
  location: {
    eyebrow: { en: "Location", es: "Ubicación" },
    title1: { en: "Todos Santos, a town", es: "Todos Santos, un pueblo" },
    title2: { en: "of charm and art.", es: "con encanto y arte." },
    intro: {
      en: "Discover Todos Santos, a picturesque and artistic “Magic Town”, set between the majestic Pacific Ocean and the imposing Sierra Madre.",
      es: "Descubra Todos Santos, un pintoresco y artístico “Pueblo Mágico”, ubicado entre el majestuoso Océano Pacífico y la imponente Sierra Madre."
    },
    text: {
      en: "Just one hour west of Los Cabos and south of La Paz, this peaceful corner of Baja California Sur is a carefully preserved treasure. NACUII sits in the privileged Las Tunas neighborhood, a five-minute walk from the ocean.",
      es: "A solo una hora al oeste de Los Cabos y al sur de La Paz, este tranquilo rincón de Baja California Sur es un tesoro cuidadosamente preservado. NACUII se asienta en el privilegiado barrio de Las Tunas, a cinco minutos caminando del mar."
    },
    cards: [
      {
        title: { en: "Las Tunas, Todos Santos", es: "Las Tunas, Todos Santos" },
        desc: {
          en: "Prestigious neighborhood, 5-minute walk to La Pastora beach.",
          es: "Barrio prestigioso, a 5 min. caminando de la playa La Pastora."
        }
      },
      {
        title: { en: "70 min from Los Cabos", es: "70 min de Los Cabos" },
        desc: {
          en: "Los Cabos and La Paz International Airports.",
          es: "Aeropuertos Internacionales de Los Cabos y La Paz."
        }
      },
      {
        title: { en: "East/West Orientation", es: "Orientación Este/Oeste" },
        desc: {
          en: "Direct view of the sunset over the Pacific.",
          es: "Vista directa a la puesta del sol sobre el Pacífico."
        }
      }
    ]
  },
  exclusivity: {
    eyebrow: { en: "Exclusivity & Privacy", es: "Exclusividad & Privacidad" },
    title1: { en: "Not just a residence.", es: "No es solo una residencia." },
    title2: { en: "A dream sanctuary.", es: "Es un refugio de ensueño." },
    intro: {
      en: "Where luxury, comfort and natural beauty merge to create an unparalleled living experience.",
      es: "Donde el lujo, la comodidad y la belleza natural se fusionan para crear una experiencia de vida inigualable."
    },
    features: [
      {
        en: "Unique residence in the area, exclusive and functional.",
        es: "Única residencia en la zona, exclusiva y funcional."
      },
      {
        en: "Comfort and design in every space.",
        es: "Confort y diseño en cada espacio."
      },
      {
        en: "Unparalleled Pacific Ocean views.",
        es: "Incomparables vistas al mar Pacífico."
      },
      {
        en: "3,000 m² lot, a 5-minute walk from the beach.",
        es: "Terreno de 3,000 m² a 5 minutos caminando de la playa."
      },
      {
        en: "Dual vehicular access: main roundabout and service entrance.",
        es: "Doble entrada vehicular: glorieta principal y servicios."
      },
      {
        en: "Spa with dry sauna and massage room (optional).",
        es: "Spa con sauna seco y sala de masajes (opcional)."
      },
      {
        en: "BBQ palapa and fire pit.",
        es: "Palapa de BBQ y fire pit."
      }
    ]
  },
  contact: {
    eyebrow: { en: "Contact us", es: "Contáctenos" },
    title1: { en: "Schedule a private", es: "Reserve una visita" },
    title2: { en: "viewing.", es: "privada." },
    intro: {
      en: "Exclusive listing. For acquisition inquiries, guided viewings or private events, we will be delighted to assist you.",
      es: "Listing exclusivo. Para consultas de adquisición, visitas guiadas o eventos privados, estaremos encantados de atenderle."
    },
    role: { en: "Executive Realtor — Exclusive Listing", es: "Executive Realtor — Listing Exclusivo" },
    listingTag: { en: "Exclusive listing", es: "Listing Exclusivo" },
    emailLabel: { en: "Email", es: "Correo" },
    phoneLabel: { en: "Phone & WhatsApp", es: "Teléfono & WhatsApp" },
    locationLabel: { en: "Location", es: "Ubicación" },
    location: {
      en: "Las Tunas, Todos Santos, Baja California Sur, Mexico",
      es: "Las Tunas, Todos Santos, Baja California Sur, México"
    },
    form: {
      name: { en: "Full name", es: "Nombre completo" },
      email: { en: "Email address", es: "Correo electrónico" },
      phone: { en: "Phone number", es: "Teléfono" },
      message: { en: "Your message", es: "Su mensaje" },
      send: { en: "Send message", es: "Enviar mensaje" },
      sending: { en: "Sending…", es: "Enviando…" },
      successTitle: { en: "Thank you for your message", es: "Gracias por contactarnos" },
      successDesc: {
        en: "We will get back to you as soon as possible.",
        es: "Le responderemos lo antes posible."
      }
    }
  },
  footer: {
    tagline: { en: "Todos Santos — Baja California Sur", es: "Todos Santos — Baja California Sur" },
    description: {
      en: "An exclusive residence facing the Pacific. Where elegance, nature and design come together to create an unforgettable retreat.",
      es: "Una exclusiva residencia frente al Pacífico. Donde la elegancia, la naturaleza y el diseño se encuentran para crear un refugio inolvidable."
    },
    navTitle: { en: "Navigation", es: "Navegación" },
    contactTitle: { en: "Contact", es: "Contacto" },
    rights: { en: "All Rights Reserved.", es: "Todos los derechos reservados." },
    listing: { en: "Private listing · NACUII Residence", es: "Listing privado · Residencia NACUII" }
  },
  whatsappMessage: {
    en: "Hello, I would like to know more about the NACUII residence in Todos Santos.",
    es: "Hola, me interesa conocer más sobre la residencia NACUII en Todos Santos."
  },
  rates: {
    eyebrow: { en: "Rates & Bookings", es: "Tarifas & Reservas" },
    title1: { en: "Reserve your", es: "Reserve su" },
    title2: { en: "private retreat.", es: "refugio privado." },
    intro: {
      en: "Nightly rates per residence. All seasons require a minimum stay; weekly and monthly stays receive special discounts.",
      es: "Tarifas por noche para la residencia completa. Todas las temporadas requieren estancia mínima; las estancias semanales y mensuales reciben descuentos especiales."
    },
    perNight: { en: "per night", es: "por noche" },
    seasons: [
      {
        season: { en: "High Season", es: "Temporada Alta" },
        period: { en: "November 1 \u2013 April 30", es: "1 de noviembre \u2013 30 de abril" },
        price: 1150,
        minNights: { en: "Minimum 2 nights", es: "Mínimo 2 noches" },
        featured: true
      },
      {
        season: { en: "Mid Season", es: "Temporada Media" },
        period: { en: "May \u00b7 June \u00b7 October", es: "Mayo \u00b7 Junio \u00b7 Octubre" },
        price: 1150,
        minNights: { en: "Minimum 2 nights", es: "Mínimo 2 noches" },
        featured: false
      },
      {
        season: { en: "Low Season", es: "Temporada Baja" },
        period: { en: "July \u00b7 August \u00b7 September", es: "Julio \u00b7 Agosto \u00b7 Septiembre" },
        price: 930,
        minNights: { en: "Minimum 2 nights", es: "Mínimo 2 noches" },
        featured: false
      },
      {
        season: { en: "Holiday Premium", es: "Temporada Premium" },
        period: {
          en: "Easter \u00b7 Thanksgiving \u00b7 Christmas \u00b7 New Year",
          es: "Semana Santa \u00b7 Thanksgiving \u00b7 Navidad \u00b7 Año Nuevo"
        },
        price: 2250,
        minNights: { en: "Minimum 5 nights", es: "Mínimo 5 noches" },
        featured: false
      }
    ],
    addonsTitle: { en: "Services & Add-ons", es: "Servicios Adicionales" },
    addons: [
      {
        name: { en: "Standard Cleaning", es: "Limpieza Estándar" },
        desc: {
          en: "End-of-stay cleaning service.",
          es: "Servicio de limpieza al término de la estancia."
        },
        price: 350,
        unit: { en: "one-time", es: "única vez" }
      },
      {
        name: { en: "Daily Cleaning", es: "Limpieza Diaria" },
        desc: {
          en: "Optional daily housekeeping (8 hours).",
          es: "Limpieza diaria opcional (8 horas)."
        },
        price: 150,
        unit: { en: "per day", es: "por día" }
      },
      {
        name: { en: "Private Events", es: "Eventos Privados" },
        desc: {
          en: "Special events with more than 15 guests.",
          es: "Eventos especiales con más de 15 invitados."
        },
        price: 2500,
        unit: { en: "per event", es: "por evento" }
      }
    ],
    discountsTitle: { en: "Long-Stay Discounts", es: "Descuentos por Estancias Largas" },
    discounts: [
      {
        name: { en: "Full Week", es: "Semana Completa" },
        value: "10%",
        desc: {
          en: "Discount on 7+ consecutive nights.",
          es: "Descuento en 7 o más noches consecutivas."
        }
      },
      {
        name: { en: "Full Month", es: "Mes Completo" },
        value: "25%",
        desc: {
          en: "Discount on 30+ consecutive nights.",
          es: "Descuento en 30 o más noches consecutivas."
        }
      }
    ],
    cta: { en: "Inquire about availability", es: "Consultar disponibilidad" },
    note: {
      en: "All rates in USD. Final pricing depends on dates, length of stay and selected services. Please contact us for a personalized quote.",
      es: "Todas las tarifas en USD. El precio final depende de las fechas, duración de la estancia y servicios seleccionados. Contáctenos para una cotización personalizada."
    }
  },
  faq: {
    eyebrow: { en: "Frequently Asked Questions", es: "Preguntas Frecuentes" },
    title1: { en: "Everything you", es: "Todo lo que" },
    title2: { en: "need to know.", es: "necesita saber." },
    intro: {
      en: "Find answers to the most common questions about staying at NACUII. For anything else, our team is one click away.",
      es: "Encuentre respuestas a las preguntas más comunes sobre su estancia en NACUII. Para cualquier otra consulta, nuestro equipo está a un clic de distancia."
    },
    items: [
      {
        q: { en: "How do I make a reservation?", es: "¿Cómo realizo una reserva?" },
        a: {
          en: "You can request a reservation through the contact form on this site, by email, by phone or via WhatsApp. Once we confirm availability for your dates, we will send you a personalized quote and the booking instructions.",
          es: "Puede solicitar una reserva a través del formulario de contacto, por correo electrónico, teléfono o WhatsApp. Una vez confirmada la disponibilidad para sus fechas, le enviaremos una cotización personalizada y las instrucciones de reserva."
        }
      },
      {
        q: { en: "What is the minimum stay?", es: "¿Cuál es la estancia mínima?" },
        a: {
          en: "The minimum stay is 2 nights for regular dates and 5 nights during Easter, Thanksgiving, Christmas and New Year holidays.",
          es: "La estancia mínima es de 2 noches en fechas regulares y 5 noches durante Semana Santa, Thanksgiving, Navidad y Año Nuevo."
        }
      },
      {
        q: { en: "What is included in the rate?", es: "¿Qué incluye la tarifa?" },
        a: {
          en: "The nightly rate includes the full residence with up to 5 bedrooms, all amenities (infinity pool, jacuzzi, palapa & BBQ, fire pit, pool lounge), Wi-Fi, utilities and air conditioning. Cleaning is charged separately.",
          es: "La tarifa por noche incluye la residencia completa con hasta 5 recámaras, todas las amenidades (alberca infinita, jacuzzi, palapa & BBQ, fire pit, área de descanso), Wi-Fi, servicios y aire acondicionado. La limpieza se cobra por separado."
        }
      },
      {
        q: { en: "Are events and weddings allowed?", es: "¿Se permiten eventos y bodas?" },
        a: {
          en: "Yes. Private events with more than 15 guests have a special fee of 2,500 USD. We are happy to host weddings, retreats, photoshoots and special celebrations \u2014 please reach out so we can plan it together.",
          es: "Sí. Los eventos privados con más de 15 invitados tienen una tarifa especial de 2,500 USD. Recibimos bodas, retiros, sesiones fotográficas y celebraciones especiales \u2014 contáctenos para planificarlo juntos."
        }
      },
      {
        q: { en: "Do you offer long-stay discounts?", es: "¿Ofrecen descuentos por estancias largas?" },
        a: {
          en: "Yes. Stays of 7+ consecutive nights receive a 10% discount, and stays of 30+ consecutive nights receive a 25% discount.",
          es: "Sí. Estancias de 7 o más noches consecutivas reciben un 10% de descuento, y estancias de 30 o más noches consecutivas reciben un 25% de descuento."
        }
      },
      {
        q: { en: "How far is the airport?", es: "¿A qué distancia está el aeropuerto?" },
        a: {
          en: "NACUII is approximately 70 minutes from Los Cabos International Airport (SJD) and 70 minutes from La Paz International Airport (LAP). We can arrange private airport transfers upon request.",
          es: "NACUII está a aproximadamente 70 minutos del Aeropuerto Internacional de Los Cabos (SJD) y 70 minutos del Aeropuerto Internacional de La Paz (LAP). Podemos coordinar traslados privados bajo solicitud."
        }
      },
      {
        q: { en: "How far is the beach?", es: "¿Qué tan cerca está la playa?" },
        a: {
          en: "The famous La Pastora surf beach is just a 5-minute walk from the residence. Downtown Todos Santos and its restaurants, galleries and shops are a 10-minute drive away.",
          es: "La famosa playa de surf La Pastora está a solo 5 minutos caminando de la residencia. El centro de Todos Santos con sus restaurantes, galerías y tiendas está a 10 minutos en automóvil."
        }
      },
      {
        q: { en: "What is the cancellation policy?", es: "¿Cuál es la política de cancelación?" },
        a: {
          en: "The cancellation policy depends on the dates and length of stay. Full details will be shared at the moment of booking. We recommend purchasing travel insurance for peace of mind.",
          es: "La política de cancelación depende de las fechas y la duración de la estancia. Los detalles completos se comparten al momento de la reserva. Recomendamos contratar un seguro de viaje para mayor tranquilidad."
        }
      }
    ],
    cta: { en: "Have another question?", es: "¿Tiene otra pregunta?" },
    ctaButton: { en: "Contact us", es: "Contáctenos" }
  }
};

export const galleryItems = [
  // Exterior - real photos from Drive
  { id: 101, src: driveImages.houseNight, captionEn: "Illuminated facade at night", captionEs: "Fachada iluminada al anochecer", category: "exterior" },
  { id: 102, src: driveImages.exteriorRender1, captionEn: "Exterior with cactus", captionEs: "Exterior con cactus", category: "exterior" },
  { id: 103, src: driveImages.exteriorRender2, captionEn: "Front entrance", captionEs: "Entrada principal", category: "exterior" },
  { id: 104, src: driveImages.exteriorFlowers, captionEn: "Garden detail", captionEs: "Detalle de jardín", category: "exterior" },
  { id: 105, src: driveImages.poolInfinity, captionEn: "Infinity pool", captionEs: "Alberca infinita", category: "exterior" },
  { id: 106, src: driveImages.poolFountain, captionEn: "Pool & lounge", captionEs: "Alberca y descanso", category: "exterior" },
  { id: 107, src: driveImages.villaPoolView, captionEn: "Villa overview", captionEs: "Vista general de la villa", category: "exterior" },
  { id: 108, src: driveImages.oceanTerrace, captionEn: "Ocean terrace", captionEs: "Terraza al mar", category: "exterior" },
  { id: 109, src: driveImages.outdoorTerrace, captionEn: "Outdoor terrace", captionEs: "Terraza exterior", category: "exterior" },
  { id: 110, src: driveImages.firepitArea, captionEn: "Fire pit lounge", captionEs: "Sala fire pit", category: "exterior" },
  { id: 111, src: driveImages.palapaDining, captionEn: "Palapa dining", captionEs: "Palapa comedor", category: "exterior" },
  { id: 112, src: driveImages.palapaWooden, captionEn: "Wooden palapa", captionEs: "Palapa de madera", category: "exterior" },
  { id: 113, src: driveImages.outdoorKitchen, captionEn: "Outdoor Fireplace", captionEs: "Chimenea Exterior", category: "exterior" },
  { id: 114, src: driveImages.bbqGrill, captionEn: "BBQ area", captionEs: "Área de asador", category: "exterior" },
  { id: 115, src: driveImages.sunsetView, captionEn: "Sunset view", captionEs: "Vista al atardecer", category: "exterior" },
  // Interior
  { id: 201, src: driveImages.livingDining, captionEn: "Living & dining", captionEs: "Sala y comedor", category: "interior" },
  { id: 202, src: driveImages.livingDining2, captionEn: "Open living area", captionEs: "Área social abierta", category: "interior" },
  { id: 203, src: driveImages.kitchenIsland, captionEn: "Kitchen", captionEs: "Cocina", category: "interior" },
  { id: 204, src: driveImages.livingTV, captionEn: "TV lounge", captionEs: "Sala de TV", category: "interior" },
  { id: 205, src: driveImages.bedroomQueen, captionEn: "Master bedroom", captionEs: "Recámara principal", category: "interior" },
  { id: 206, src: driveImages.bedroomGarden, captionEn: "Garden suite", captionEs: "Suite con jardín", category: "interior" },
  { id: 207, src: driveImages.bedroomTwin, captionEn: "Twin bedroom", captionEs: "Recámara doble", category: "interior" },
  { id: 208, src: driveImages.bathroomTub, captionEn: "Bathroom with tub", captionEs: "Baño con tina", category: "interior" },
  { id: 209, src: driveImages.bathroomDoubleVanity, captionEn: "Double vanity", captionEs: "Doble lavabo", category: "interior" },
  { id: 210, src: driveImages.bathroomSingleVanity, captionEn: "Vanity detail", captionEs: "Detalle de lavabo", category: "interior" }
];

export const contactInfo = {
  agents: ["Persloto", "M. Peri"],
  emails: ["perslot76@gmail.com", "mperi2805@gmail.com"],
  phones: ["+52 55 4337 5900", "+52 55 4235 5989"],
  whatsapp: "+525543375900"
};

export const navItems = [
  { key: "home", href: "#inicio" },
  { key: "residence", href: "#residencia" },
  { key: "architecture", href: "#arquitectura" },
  { key: "gallery", href: "#galeria" },
  { key: "amenities", href: "#amenidades" },
  { key: "rates", href: "#tarifas" },
  { key: "location", href: "#ubicacion" },
  { key: "faq", href: "#faq" },
  { key: "contact", href: "#contacto" }
];
